// Mirrored from TinyAI db schema

export type MessageSenderType = 'user' | 'assistant' | 'system';

export interface CitationSource {
  title: string;
  url: string;
  score?: number;
}

export interface ChatMessageMetadata {
  sources?: CitationSource[];
  isError?: boolean;
  errorCategory?: string | null;
  errorCode?: string | null;
  [key: string]: unknown;
}

export interface ChatMessage {
  id: string;
  conversationId: string;
  messageText: string;
  senderType: MessageSenderType;
  metadataJson: ChatMessageMetadata | null;
  createdAt: string;
  hasFeedback?: boolean;
}

export interface Conversation {
  id: string;
  userId: string;
  conversationName: string | null;
  title: string | null;
  lastMessage: string | null;
  metadataJson: Record<string, unknown> | null;
  createdAt: string;
  updatedAt: string;
}

export type DisplayLocation =
  | 'results_mss'
  | 'results_chatbot'
  | 'all_insights_chatbot'
  | 'action_plan_chatbot'
  | 'metric_chatbot'
  | 'conditions_detail_page';

export enum TinyAIPageSource {
  RESULTS = 'results',
  INSIGHTS = 'insights',
  ACTION_PLAN = 'action_plan',
  ACCOUNT = 'account',
  HELP = 'help',
  COMMUNITY = 'community',
  KITS = 'kits',
  HOME = 'home',
  OTHER = 'other',
}

/**
 * Page context for TinyAI interactions.
 * Matches backend resultsPortalContextSchema.
 */
export interface TinyAIPageContext {
  url?: string;
  userMetadata?: Record<string, unknown>;
  kitId?: string;
  tinyAccountId?: string;
  isPregnant?: boolean;
  isPredefinedPrompt?: boolean;
  source?: TinyAIPageSource;
  actionPlanItemId?: string;
  subMetricId?: string;
  /** @deprecated */
  category?: string;
}

export interface ChatbotPrompt {
  id: number;
  prompt_text: string;
  display_order: number;
  display_location: DisplayLocation;
  is_active: boolean;
}
